<template>
	<div>
		<div class="topTitle">门店运营数据监测</div>
		<div class="first_line">
			<div class="right_warp">
				<span class="demonstration">月份</span>
				<el-date-picker v-model="filter.month" type="month" placeholder="选择月" size="small"
					value-format="yyyy-MM">
				</el-date-picker>
				<el-select @change="getlist()" v-model="filter.storeId" placeholder="全部门店" clearable
					style="margin-left: 10px;" size="small">
					<el-option-group label="营业门店" class="store">
						<el-option v-for="item in storeList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
					<el-option-group label="结业门店">
						<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
				</el-select>
				<el-select @change="getlist()" v-model="filter.type" placeholder="门店属性" clearable
					style="margin-left: 10px;" size="small">
					<el-option-group label="营业门店" class="store">
						<el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-option-group>
				</el-select>
				<el-button type="primary" style=" position: relative;margin-left: 10px" @click="getlist()"
					size="small">筛
					选</el-button>
			</div>
			<el-button type="info" style="dispaly:flex;float:right" size="small"  @click="expro()">导出</el-button>
		</div>
		<div>
			<el-table :cell-style="{'text-align':'center'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="tableData"
				tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="month" label="月份"></el-table-column>
				<el-table-column prop="storeName" label="门店"></el-table-column>
				<el-table-column prop="totalIncome" label="总营收"></el-table-column>
				<el-table-column prop="newCustomer" label="新客数"></el-table-column>
				<el-table-column prop="meituanCustomer" label="美团单数"></el-table-column>
				<el-table-column prop="douyinCustomer" label="抖音单数"></el-table-column>
				<el-table-column prop="totalCustomer" label="总客数"></el-table-column>
				<el-table-column prop="taocanCustomer" label="套餐数"></el-table-column>
				<el-table-column prop="taocanIncome" label="套餐营收"></el-table-column>
				<el-table-column prop="haircutCustomer" label="剪发单数"></el-table-column>
				<el-table-column prop="colorCustomer" label="染护单数"></el-table-column>
				<el-table-column prop="colorInAll" label="染护占比">
					<template slot-scope="scope">
						{{scope.row.colorInAll==0?"0":(scope.row.colorInAll*100).toFixed(2)}}%
					</template>
				</el-table-column>
				<el-table-column prop="chengben" label="总成本">
					<template slot-scope="scope">
						{{scope.row.chengben==null?"0":scope.row.chengben}}
					</template>
				</el-table-column>
				<el-table-column prop="yingli" label="利润">
					<template slot-scope="scope">
						<span v-if="scope.row.yingli>0" style="color:limegreen">
							{{scope.row.yingli}}
						</span>
						<span v-else  style="color:red">
							{{scope.row.yingli==null?"0":scope.row.yingli}}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="lilv" label="净利率">
					<template slot-scope="scope">
						<span v-if="scope.row.lilv>0" style="color:limegreen">
							{{(scope.row.lilv*100).toFixed(2)}}%
						</span>
						<span v-else style="color:red">
							{{scope.row.lilv==null?"0":(scope.row.lilv*100).toFixed(2)}}%
						</span>
						<!-- {{scope.row.lilv==null?"0":scope.row.lilv}}% -->
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	import format from "../../../utils/index.js"
	import {
		export2Excel
	} from '../../../common/js/util'
	export default {
		data() {
			return {
				tableData: [],
				filter: {
					month: new Date().getFullYear() + '-' + (new Date().getMonth() < 10 ?'0'+( new Date().getMonth() + 1) :
						new Date().getMonth() + 1),
					storeId: "",
				},
				storeEnd: [],
				storeList: [],
				type: [{
						value: 1,
						label: "直营店"
					},
					// ,{
					// 	value:2,
					// 	label:"合作店"
					// },{
					// 	value:3,
					// 	label:"联名店"
					// },{
					// 	value:4,
					// 	label:"旗舰店"
					// },{
					// 	value:5,
					// 	label:"地铁店"
					// },
					{
						value: 6,
						label: "加盟店"
					}
				],
				// storeType:[{
				// 	value:0,
				// 	label:"直营店"
				// },{
				// 	value:1,
				// 	label:"加盟店"
				// }]
				columns: [{
					title: '月份',
					key: 'month'
				}, {
					title: '门店',
					key: 'storeName'
				}, {
					title: '总营收',
					key: 'totalIncome'
				}, {
					title: '新客数',
					key: 'newCustomer'
				}, {
					title: '美团单数',
					key: 'meituanCustomer'
				}, {
					title: '抖音单数',
					key: 'douyinCustomer'
				}, {
					title: '总客数',
					key: 'totalCustomer'
				}, {
					title: '套餐数',
					key: 'taocanCustomer'
				}, {
					title: '套餐营收',
					key: 'taocanIncome'
				}, {
					title: '剪发单数',
					key: 'haircutCustomer'
				}, {
					title: '染护单数',
					key: 'colorCustomer'
				}, {
					title: '染护占比(%)',
					key: 'colorInAll'
				}, {
					title: '总成本',
					key: 'chengben'
				}, {
					title: '利润',
					key: 'yingli'
				}, {
					title: '净利率(%)',
					key: 'lilv'
				}]
			};
		},
		mounted() {
			this.getStores()
			this.getlist()
		},
		methods: {
			// 获取门店列表
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 1) {
							this.storeEnd.push(ele) //结业门店
						} else {
							this.storeList.push(ele) //营业门店
						}
					})
				})
			},
			getlist() {
				var a = "?month=" + this.filter.month
				if (this.filter.storeId) {
					a = a + "&storeId=" + this.filter.storeId
				}
				if (this.filter.type) {
					a = a + "&type=" + this.filter.type
				}
				this.$http.get("data/storeRevenueData" + a).then(
					function(res) {
						this.tableData = res.body.data
						this.tableData.map(ele=>{
							ele.colorInAll = ele.colorInAll/100
							ele.lilv =  ele.lilv/100
						})
					},
					function(err) {
						this.$message.error("请求失败")
					})
			},
			expro() {
				this.tableData.forEach(ele=>{
					if(ele.colorInAll ==null){
						ele.colorInAll = 0
					}
					if(ele.chengben ==null){
						ele.chengben = 0
					}
					if(ele.yingli ==null){
						ele.yingli = 0
					}
					if(ele.lilv ==null){
						ele.lilv = 0
					}
				})
				export2Excel(this.columns, this.tableData)
			}
		}
	};
</script>
<style lang="less" scoped>
	.topTitle {
		font-weight: blod;
		font-size: 22px;
		color: #707070;
	}

	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}
	
	/deep/.el-select-dropdown__item {
		width:220px;
	}
</style>